var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutputExportToFileSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#009ad9;}.cls-2{fill:#363545;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "OutputExportToFile_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "xaml"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "30 16 22 24 22 19 13 19 13 13 22 13 22 8 30 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "16 21 16 26 13 26 10.67 26 10 26 6 26 2 26 2 13 8 13 8 6 16 6 16 11 18 11 18 4 7.04 4 0 10.75 0 28 6 28 10 28 11.26 28 11.67 28 13 28 16 28 18 28 18 26 18 21 16 21"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutputExportToFileSvg);
export default __webpack_public_path__ + "static/media/OutputExportToFile_svg.7f766a99caa42859ab2072cf3cd1d89f.svg";
export { ForwardRef as ReactComponent };